import {palette} from './theme';
export const SEGMENT_COLORS = [
  palette.greenHaze,
  palette.supernova,
  palette.alizarinCrimson,
];
export const SEGMENT_STOPS = [0, 40, 80, 100];
